module.exports = "div { float: left; }\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/create-workspace/machine-list/machine-list.component.css
// module id = ./src/app/create-workspace/machine-list/machine-list.component.css
// module chunks = main